import React from 'react';
import { LoanTerms } from '@/types/pool';
import { formatCurrency } from '@/utils/misc';
import { computeLoanDetails } from '@/utils/poolCalculations';
import { getLoanTypeLabel, formatTermDisplay } from '@/utils/poolCreateUtils';
import { InfoField } from './InfoField';

type LoanTermsInfoDisplayProps = {
  loanTerms: LoanTerms;
  className?: string;
};

export const LoanTermsInfoDisplay: React.FC<LoanTermsInfoDisplayProps> = ({ loanTerms, className = '' }) => {
  const loanDetails = computeLoanDetails(
    parseFloat(loanTerms.amount),
    parseFloat(loanTerms.roi_rate),
    loanTerms.loan_type,
    loanTerms.term_months
  );
  const roiAmount = loanDetails.roiAmount;

  return (
    <div className={`grid grid-cols-2 gap-8 ${className}`}>
      {/* Left Column */}
      <div className="flex flex-col gap-4">
        <InfoField label="Investment" value={formatCurrency(loanTerms.amount)} size="large" />
        <InfoField label="Interest rate" value={`${loanTerms.roi_rate}%`} size="large" />
        <InfoField label="Pool Program" value={getLoanTypeLabel(loanTerms.loan_type)} size="large" />
      </div>

      {/* Right Column */}
      <div className="flex flex-col gap-4">
        <InfoField label="ROI (Return on Investment)" value={formatCurrency(roiAmount.toString())} size="large" />
        <InfoField label="Term" value={formatTermDisplay(loanTerms.term_months)} size="large" />
      </div>
    </div>
  );
};
